import type { Voucher } from '@src/domains/vouchers/types/voucher';
import type { VoucherDownloadTarget } from '@src/domains/vouchers/types/voucherDownload';
import { isVoucherDownloadable } from '@src/domains/vouchers/core/isVoucherDownloadable';
import { isVoucherPending } from '@src/domains/vouchers/core/isVoucherPending';

interface Params {
  reservationId: string | null;
  vouchers: Voucher[];
}

export function resolveVoucherDownloadTarget({ reservationId, vouchers }: Params): VoucherDownloadTarget[] {
  const downloadable = vouchers.filter(isVoucherDownloadable);

  if (reservationId) {
    if (vouchers.some(isVoucherPending)) {
      return [];
    }

    if (downloadable.length > 0 && downloadable.length === vouchers.length) {
      return [{ kind: 'reservation', id: reservationId }];
    }

    return downloadable.map((voucher) => ({ kind: 'voucher', id: voucher.id }));
  }

  return downloadable.map((voucher) => ({ kind: 'voucher', id: voucher.id }));
}
